import { Info } from "@phosphor-icons/react";
import { cva, type VariantProps } from "class-variance-authority";

import type { JSX, ReactNode } from "react";

const bannerVariants = cva("flex gap-x-2 rounded-3xl px-4 py-3 shadow-sm", {
  variants: {
    variant: {
      warning: "border border-yellow-400 bg-white",
      gradient:
        "bg-[url(/images/free-trial-banner-bg.png)] bg-cover border border-purple-100",
      info: "border border-black-200 bg-white",
    },
  },
});

interface BannerProps extends Required<VariantProps<typeof bannerVariants>> {
  textNode: ReactNode;
  ctaComponent?: JSX.Element;
}

export default function Banner({
  variant,
  textNode,
  ctaComponent,
}: BannerProps) {
  return (
    <article className={bannerVariants({ variant })}>
      <Info weight="fill" size={16} />
      <div className="flex flex-col gap-y-2.5">
        <p className="text-xs">{textNode}</p>
        {ctaComponent}
      </div>
    </article>
  );
}
